import { Component, Input, OnInit } from "@angular/core";
import { PaymentCard } from "../../../account.module";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { UserService } from "app/auth/service";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-general",
  templateUrl: "./general.component.html",
  styleUrls: ["./general.component.scss"],
})
export class GeneralComponent implements OnInit {
  @Input() paymentCards;

  private _unsubscribeAll: Subject<any>;

  public society: any;

  public showSocietyModal: boolean = false;
  public fadeoutSocietyModal: boolean = false;

  public editSocietyDetails: FormGroup;

  public modalLoadingButton: boolean = false;

  public formErrors: Object = {
    nbErrors: 0,
    name: null,
    street: null,
    street2: null,
    postal_code: null,
    city: null,
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService
  ) {
    this._unsubscribeAll = new Subject();
  }

  public removePaymentCard(cardId): void {
    this.paymentCards.splice(
      this.paymentCards.findIndex((p: PaymentCard) => p.id === cardId),
      1
    );
  }

  public toggleSocietyModal(): void {
    if (this.showSocietyModal) {
      this.fadeoutSocietyModal = true;
      setTimeout(() => {
        this.showSocietyModal = false;
        this.fadeoutSocietyModal = false;
      }, 300);
    } else {
      this.showSocietyModal = true;
    }
  }

  public updateSocietyDetails() {
    this.formErrors["nbErrors"] = 0;
    this.modalLoadingButton = true;
    Object.entries(this.editSocietyDetails.controls).forEach((control) => {
      if (control[1].status == "INVALID") {
        this.formErrors[control[0]] = true;
        this.formErrors["nbErrors"]++;
      } else {
        this.formErrors[control[0]] = null;
      }
    });

    this.editSocietyDetails.patchValue({
      repository: String(this.editSocietyDetails.value.repository),
    });

    this._userService
      .editSocietyDetails(this.editSocietyDetails.value)
      .subscribe(
        (data) => {
          console.log(data);
          this.modalLoadingButton = false;
          this.toggleSocietyModal();
          this.getSocietyData();
        },
        (error) => {
          console.log(error);
          this.modalLoadingButton = false;
        }
      );
  }

  private getSocietyData() {
    this._userService
      .getCurrentSociety()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
        (res) => {
          this.society = res.data;

          this.editSocietyDetails = this._formBuilder.group({
            name: [this.society.name, [Validators.required]],
            street: [this.society.street, [Validators.required]],
            street2: [this.society.street2, [Validators.required]],
            postal_code: [this.society.postal_code, [Validators.required]],
            city: [this.society.city, [Validators.required]],
          });
        },
        (err) => {
          console.error({ err });
        }
      );
  }

  ngOnInit(): void {
    this.editSocietyDetails = this._formBuilder.group({
      name: [null, [Validators.required]],
      street: [null, [Validators.required]],
      street2: [null, [Validators.required]],
      postal_code: [null, [Validators.required]],
      city: [null, [Validators.required]],
    });

    this.getSocietyData();
  }
}
